<template>
  <div>
    <div class="app-nav">
      <div class="row expanded">
        <div class="columns">
          <nav></nav>
        </div>
      </div>
    </div>
    <h3 class="subtitle has-text-white">Sorry. We couldn't find that Page.</h3>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>